/* eslint-disable import/first */
import './nonce-config';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'core-js/actual/object/has-own';

import { StyleSheetManager } from 'styled-components';

ReactDOM.render(
  <StyleSheetManager
    nonce={(window as any).__CSP_NONCE__}
    target={document.head}
  >
    <App />
  </StyleSheetManager>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
